module.exports = __webpack_public_path__ + "static/img/cultureItem4.0c4e709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/cultureItem4.png
// module id = 2Su/
// module chunks = 0